export default __webpack_public_path__ + "static/page-header-do-2-2e813befe688bfb12771485f7b4b5f01dea33beca74886ce7b4225599417d014.png";